/**
 * OrgEmployee Store Selectors
 *
 * Contains all selector functions for the orgEmployee store.
 *
 * @module @store/orgEmployee/orgEmployeeSelectors
 */

import type { OrgEmployeeState } from './orgEmployeeTypes';
import type { OrgEmployee } from '@shared/types';

/**
 * Type-safe selector for orgEmployee.
 */
export const selectOrgEmployee = (
    state: OrgEmployeeState,
): OrgEmployee | null => state.orgEmployee;

/**
 * Type-safe selector for isLoading.
 */
export const selectOrgEmployeeLoading = (state: OrgEmployeeState): boolean =>
    state.isLoading;

/**
 * Type-safe selector for error.
 */
export const selectOrgEmployeeError = (
    state: OrgEmployeeState,
): string | null => state.error;
